/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckoutItem } from './CheckoutItem';
export type CheckoutRequest = {
    items: Array<CheckoutItem>;
    delivery_method?: CheckoutRequest.delivery_method;
    payment_method?: CheckoutRequest.payment_method;
};
export namespace CheckoutRequest {
    export enum delivery_method {
        SUPPLIER = 'supplier',
        PICKUP = 'pickup',
        COURIER = 'courier',
        TERMINAL = 'terminal',
        ADDRESS = 'address',
    }
    export enum payment_method {
        CARD = 'card',
        BANK_TRANSFER = 'bank_transfer',
        CREDIT = 'credit',
    }
}

